module.exports = __webpack_public_path__ + "static/media/password.60aad3bb.svg";